import { render, staticRenderFns } from "./AdminLocale.vue?vue&type=template&id=32a0d23a&scoped=true&"
import script from "./AdminLocale.vue?vue&type=script&lang=js&"
export * from "./AdminLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a0d23a",
  null
  
)

export default component.exports